import * as React from "react";

import Debug from "@/react/debug";
import { useErrorNotification } from "@/react/notifications";

import { useLazyGetJobDetailsQuery } from "./api";
import { isNil } from "lodash";
import { useNavigate } from "react-router-dom";

const useJobDetails = ({ jobId, setIsModalOpen }) => {
  const [selectedJobDetails, setSelectedJobDetails] = React.useState(null);
  const [retrieveJobDetails, { data, isFetching, error }] =
    useLazyGetJobDetailsQuery();
  const navigate = useNavigate();

  React.useEffect(() => {
    Debug.log(
      "[useJobDetails] Hook monitoring [jobId, retrieveJobDetails] triggered."
    );

    if (jobId != null) {
      Debug.log(`[useJobDetails] Calling retrieveJobDetails with id: ${jobId}`);
      retrieveJobDetails({ jobId });
    }
  }, [jobId, retrieveJobDetails]);

  React.useEffect(() => {
    Debug.log(
      "[useJobDetails] Hook monitoring [data] triggered -- opening modal.",
      JSON.parse(
        JSON.stringify({
          data,
          error,
        })
      )
    );

    setSelectedJobDetails(data);
    if (!isNil(data) && !error) {
      setIsModalOpen(true);
    } else {
      // Navigate back to the main page.
      setIsModalOpen(false);
      navigate("/jobs", { replace: true });
    }
  }, [data, error]);

  useErrorNotification(error);

  return {
    selectedJobDetails,
    isFetchingJobDetails: isFetching,
  };
};

export default useJobDetails;
